export const NotesMenu = [
  { index: "notes-1", to: "/notes/browser-cache", label: "浏览器缓存" },
  { index: "notes-2", to: "/notes/ParseUrl", label: "Url解析" },
  { index: "notes-3", to: "/notes/DeferAndAsync", label: "Defer、Async" },
  { index: "notes-4", to: "/notes/HttpsProtocol", label: "HTTPS" },
  { index: "notes-5", to: "/notes/SimpleRequest", label: "简单、复杂请求" },
  { index: "notes-6", to: "/notes/JS01", label: "JS基础(一)" },
  { index: "notes-7", to: "/notes/http", label: "HTTP协议" },
  { index: "notes-8", to: "/notes/html-basic", label: "HTML(一)" },
  { index: "notes-9", to: "/notes/BrowserTheory", label: "浏览器原理" },
  { index: "notes-10", to: "/notes/BrowserOptimize", label: "页面性能优化" },
  { index: "notes-11", to: "/notes/ES6Summary", label: "ES6总结" },
  { index: "notes-12", to: "/notes/InterviewSummary", label: "常见知识点" },
  { index: "notes-13", to: "/notes/Coding", label: "手写代码" },
  { index: "notes-14", to: "/notes/reactTheory", label: "React原理" },
  { index: "notes-15", to: "/notes/commonScene", label: "场景题目" },
  { index: "notes-16", to: "/notes/WeChatMp", label: "微信小程序" },
];
